import { NavItem } from '@data-access/shared';

export const SUBMISSION_DETAIL_ROUTES = new Set<NavItem>([
  {
    id: 'overview',
    label: 'Overview',
    path: 'overview',
  },
  {
    id: 'contacts',
    label: '',
    path: '',
  },
  // Details tab will be mapped based on user permissions
  {
    id: 'details',
    label: '',
    path: '',
  },
  // Documents tab will be mapped based on user permissions
  {
    id: 'documents',
    label: '',
    path: '',
  },
  {
    id: 'sites',
    label: 'Sites',
    path: 'sites',
  },
  {
    id: 'outcome-documents',
    label: 'Outcome Documents',
    path: 'outcome-documents',
  },
  {
    id: 'appeals',
    label: 'Appeals',
    path: 'appeals',
  },
]);
